<template>
    <modal ref="detalleRelacion" :titulo="titulo">
        <div class="row mx-0 my-2 justify-center f-17 f-600 text-muted">
            {{ filtro }}
        </div>
        <div class="overflow-auto custom-scroll" style="height:calc(50vh - 75px);">
            <div v-for="(data, idx) in tiendas" :key="idx" class="row mx-0 justify-center my-2">
                <div class="d-middle" style="width:200px;">
                    <img class="obj-cover br-5" width="50" height="50" :src="data.foto_firmada" alt="" />
                    <div class="col">
                        <p class="tres-puntos">{{ data.nombre }}</p>
                        <p class="f-14">{{ data.singular }}</p>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import MetricasAdmin from "~/services/metricas_admin"
import { mapGetters } from 'vuex'

export default {
    data(){
        return {
            ids:[],
            titulo:'',
            filtro:'',
            tiendas:[]
        }
    },
    computed: {
        ...mapGetters({
            id_cedis:'cedis/id_cedis',
            id_moneda:'cedis/id_moneda',
        }),
    },
    methods: {
        toggle(ids,titulo, filtro){
            this.$refs.detalleRelacion.toggle()
            this.ids = ids
            this.titulo = titulo
            this.filtro = filtro
            this.info_tenderos()
        },
        async info_tenderos(){
            try {
                let params = {
                    ids: this.ids,
                    id_moneda: this.id_moneda,
                    id_cedis: this.id_cedis
                }
                const { data } = await MetricasAdmin.info_tenderos(params)
                this.$validar(data)
                this.tiendas = data.tiendas

            } catch (error){
                this.error_catch(error)
            }
        },
    }
}
</script>

<style lang="css" scoped>
</style>
